import { render, staticRenderFns } from "./editLog.vue?vue&type=template&id=38661122&"
import script from "./editLog.vue?vue&type=script&lang=js&"
export * from "./editLog.vue?vue&type=script&lang=js&"
import style0 from "./editLog.vue?vue&type=style&index=0&id=38661122&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports